export const SKILLS = [
  { id: 'overall', name: 'Overall', image: 'overall.png' },
  { id: 'attack', name: 'Attack', image: 'attack.png' },
  { id: 'defence', name: 'Defence', image: 'defence.png' },
  { id: 'strength', name: 'Strength', image: 'strength.png' },
  { id: 'hitpoints', name: 'Hitpoints', image: 'hitpoints.png' },
  { id: 'ranged', name: 'Ranged', image: 'ranged.png' },
  { id: 'prayer', name: 'Prayer', image: 'prayer.png' },
  { id: 'magic', name: 'Magic', image: 'magic.png' },
  { id: 'cooking', name: 'Cooking', image: 'cooking.png' },
  { id: 'woodcutting', name: 'Woodcutting', image: 'woodcutting.png' },
  { id: 'fletching', name: 'Fletching', image: 'fletching.png' },
  { id: 'fishing', name: 'Fishing', image: 'fishing.png' },
  { id: 'firemaking', name: 'Firemaking', image: 'firemaking.png' },
  { id: 'crafting', name: 'Crafting', image: 'crafting.png' },
  { id: 'smithing', name: 'Smithing', image: 'smithing.png' },
  { id: 'mining', name: 'Mining', image: 'mining.png' },
  { id: 'herblore', name: 'Herblore', image: 'herblore.png' },
  { id: 'agility', name: 'Agility', image: 'agility.png' },
  { id: 'thieving', name: 'Thieving', image: 'thieving.png' },
  { id: 'slayer', name: 'Slayer', image: 'slayer.png' },
  { id: 'farming', name: 'Farming', image: 'farming.png' },
  { id: 'runecrafting', name: 'Runecrafting', image: 'runecraft.png' },
  { id: 'hunter', name: 'Hunter', image: 'hunter.png' },
  { id: 'construction', name: 'Construction', image: 'construction.png' },
];

export const getSkillById = (id) => SKILLS.find(skill => skill.id === id) || SKILLS[0];
